const attachUtil = (function () {
  return {
    download: function (res, filename) {
      //console.log(res);
      var blob = new Blob([res])
      var downloadElement = document.createElement("a")
      var href = window.URL.createObjectURL(blob) //创建下载的链接
      downloadElement.href = href
      downloadElement.download = filename //下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() //点击下载
      document.body.removeChild(downloadElement) //下载完成移除元素
      window.URL.revokeObjectURL(href) //释放掉blob对象
    },
  }
})()

export default attachUtil
